<template>
  <div v-if="is_active_alert_event" style="font-size:1.1rem; margin: 0; box-shadow: 0 4px 8px rgba(0,0,0,.2);" class="alert alert-danger text-center" role="alert">
    <p>
      <strong>Alert!</strong> {{active_alert_event_name}} is in progress.
      <router-link v-if="this.$route.matched[0].name !== 'AlertDashboard' && feature_g2_secure_enabled && active_alert_chat_enabled" style="color: #003466;" :to="{ name: 'AlertDashboard' }" >Access the emergency dashboard here.</router-link>
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      browser_notification_sent: false,
    }
  },
  computed: {
    ...mapGetters({
      is_active_alert_event: 'isActiveAlertEvent',
      active_alert_event_name: 'activeAlertEventName',
      active_alert_chat_enabled: 'activeAlertChatEnabled',
      feature_g2_secure_enabled: 'featureG2SecureEnabled'
    })
  },
  methods: {
    send_notification() {

      if (this.is_active_alert_event && !this.browser_notification_sent && typeof Notification !== "undefined") {
        var title = "Alert! " + this.active_alert_event_name;
        var body = this.active_alert_event_name + " is in progress.";
        var notification = new Notification(title, { body });

        notification.onclick = () => { 
          notification.close();
          window.parent.focus();
        }
        this.browser_notification_sent = true;
      }
      if (!this.is_active_alert_event && this.browser_notification_sent) {
        this.browser_notification_sent = false;
      }
    }
  },
  mounted () {
   this.send_notification()
    setInterval(() => {
      this.send_notification()
    }, 3000)
  },
}
</script>
